export const isStandardProductBarcode = (code: string): boolean =>
  /^\d{8}$|^\d{12,14}$/.test(code.trim());
